import React from "react";
import { ExternalLink } from "lucide-react";
import SocialIcon from "./SocialIcon";
import { EXPERIENCES, SOCIAL, HOME_URL, LOGO_SRC } from "../lib/brand";

export default function Footer({ config }) {
  const disclaimer =
    config?.disclaimer ||
    "Progetto fan non ufficiale, non affiliato a Bandai, Shueisha o Toei Animation. ONE PIECE, le immagini e i relativi elementi appartengono ai rispettivi titolari. Le carte virtuali non hanno valore economico.";

  return (
    <footer
      className="mt-12 bg-[#14233d] text-white rounded-t-[28px] sm:rounded-t-[32px]"
      data-testid="site-footer"
    >
      <div className="max-w-md sm:max-w-2xl lg:max-w-5xl mx-auto px-5 sm:px-8 py-8">
        <div className="grid grid-cols-2 sm:grid-cols-[1.2fr_1fr_1fr] gap-7">
          {/* brand */}
          <a href={HOME_URL} target="_blank" rel="noopener noreferrer" className="col-span-2 sm:col-span-1 flex items-center gap-3" data-testid="footer-brand-home">
            <img src={LOGO_SRC} alt="Lumacofono" className="w-16 h-16 object-contain" />
            <span className="font-display font-extrabold text-2xl">Lumacofono</span>
          </a>

          <div>
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-[#b6c5d9] mb-3">Esplora</h3>
            <nav className="flex flex-col gap-1" aria-label="Esperienze">
              {EXPERIENCES.map((e) =>
                e.current ? (
                  <span key={e.key} className="text-white font-bold text-sm py-1.5 inline-flex items-center gap-1.5" data-testid="footer-current">
                    {e.label} <span className="text-[9px] font-extrabold uppercase bg-[#7433c1] rounded-full px-1.5 py-0.5">Sei qui</span>
                  </span>
                ) : (
                  <a key={e.key} href={e.url} target={e.sameTab ? "_self" : "_blank"} rel={e.sameTab ? undefined : "noopener noreferrer"} data-testid={`footer-exp-${e.key}`} className="text-[#e0e8f3] hover:text-white text-sm py-1.5 min-h-[36px] flex items-center gap-1.5">
                    {e.label} <ExternalLink size={12} className="opacity-60" />
                  </a>
                )
              )}
            </nav>
          </div>

          <div>
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-[#b6c5d9] mb-3">Podcast e social</h3>
            <nav className="flex flex-col gap-1" aria-label="Social">
              {SOCIAL.map((s) => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.label.toLowerCase()}`} className="text-[#e0e8f3] hover:text-white text-sm py-1.5 min-h-[36px] flex items-center gap-2">
                  <SocialIcon name={s.icon} size={16} className="opacity-90 shrink-0" />
                  {s.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-white/15" data-testid="footer-disclaimer">
          <p className="text-[12px] leading-relaxed text-[#b6c5d9]">{disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
